export const SET_YEARS = 'SET_YEARS'
export const SET_QUEUE = 'SET_QUEUE'
export const SET_MAKES = 'SET_MAKES'
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const SET_ANSWER = 'SET_ANSWER'



// WEBPACK FOOTER //
// ./src/store/modules/admin/dispatch/types.js